import { Box, styled } from '@mui/material';

export { IconWrapper } from '../styled';

export const ContentWrapper = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: theme.spacing(1),
}));

export const InfoWrapper = styled(Box)(() => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	flex: 1,
}));

/** One grid cell for all children, so a message being swapped overlaps its
 *  replacement instead of adding a row and shifting the content below. */
export const SlotWrapper = styled(Box)(() => ({
	display: 'grid',
	'& > *': {
		gridArea: '1 / 1',
	},
}));
